export const LOGIN_EMAIL_CACHE_KEY = "aurora_saved_email"
export const USER_CACHE_KEY = "colegiosyh_user"
